import { Link } from 'react-router-dom';
import { DeleteButton } from '@/shared/ui/list/DeleteButton';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { deletePrivilege, fetchLevelOptions, fetchPrivileges } from './api';

const LIST_KEY = 'loyalty-privileges';

interface Privilege extends ListRow {
  id: number;
  name?: string;
  description?: string;
  label?: string;
  short_description?: string;
  image?: { thumb_140_140?: string } | null;
  levels?: Array<{ title: string }>;
}

const editPath = (id: number) => `/loyalty/privileges/edit/${id}`;

const config: ListPageConfig<Privilege> = {
  queryKey: LIST_KEY,
  title: 'Привилегии',
  boxTitle: 'Список привилегий',
  errorText: 'Ошибка загрузки привилегий',
  fetchList: fetchPrivileges,
  rows: ['data'],
  filters: [
    {
      name: 'level_id',
      label: 'Фильтрация по уровню',
      kind: 'select',
      loadOptions: fetchLevelOptions,
    },
  ],
  headerActions: (
    <Link to="/loyalty/privileges/create" className="btn btn-info pull-right">
      Создать
    </Link>
  ),
  columns: [
    { header: 'id', render: (item) => <Link to={editPath(item.id)}>{item.id}</Link> },
    {
      header: 'Обложка',
      render: (item) => item.image?.thumb_140_140 && <img src={item.image.thumb_140_140} alt="" />,
    },
    { header: 'Заголовок', render: (item) => item.name },
    { header: 'Основной текст', render: (item) => item.description },
    { header: 'Спец текст', render: (item) => item.label },
    { header: 'Текст 2-го абзаца', render: (item) => item.short_description },
    { header: 'Статус', render: (item) => item.levels?.map((level) => level.title).join(', ') },
    {
      header: 'Редактировать',
      render: (item) => (
        <Link to={editPath(item.id)} className="btn btn-success btn-sm">
          Edit
        </Link>
      ),
    },
    {
      header: 'Удалить',
      render: (item) => (
        <DeleteButton listKey={LIST_KEY} label="×" remove={() => deletePrivilege(item.id)} />
      ),
    },
  ],
};

export const PrivilegesPage = () => <GenericListPage config={config} />;
